var _path, _path2, _circle;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgNumberedList = function SvgNumberedList(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8 6h13M8 12h13M8 18h13",
    className: "icon-stroke-width"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.043 8c.37 0 .67-.3.67-.67V4.334a1 1 0 0 0-1-1H2.68a.996.996 0 0 0-.552.167l-.646.434a.473.473 0 0 0-.207.392.48.48 0 0 0 .748.397c.098-.066.194-.132.287-.197h.062V7.33c0 .37.3.67.67.67ZM2.453 10.862v-.092c0-.27.209-.482.489-.482s.478.188.478.458c0 .25-.143.468-.502.817l-1.45 1.438a.584.584 0 0 0 .41.999H4.29a.525.525 0 0 0 0-1.05H3.1v-.047l.789-.803c.639-.633.85-.985.85-1.498 0-.803-.693-1.346-1.729-1.346-1.052 0-1.811.653-1.811 1.528v.078h1.254ZM2.426 17.6c0 .267.216.482.482.482h.051c.41 0 .615.24.615.5.004.28-.236.499-.598.499a.881.881 0 0 1-.302-.052c-.318-.116-.633-.444-.971-.444-.34 0-.632.289-.491.6.234.514.798.897 1.733.897 1.015 0 1.97-.502 1.966-1.401 0-.732-.49-1.087-.96-1.118v-.065c.344-.038.837-.335.837-.998-.004-.752-.793-1.244-1.788-1.244-.865 0-1.466.316-1.726.864-.15.316.147.62.496.62.337 0 .63-.343.943-.466a.607.607 0 0 1 .222-.04c.315 0 .547.19.547.427 0 .266-.205.458-.547.458h-.027a.482.482 0 0 0-.482.482Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1.825,
    cy: 10.838,
    r: 0.627,
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgNumberedList);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;